import React from 'react';
import { useSelector } from 'react-redux';

import { getViewForChart, getVisibleEntriesForView } from '../../redux/sonar/sonarSelectors';
import { SONAR_SECTIONS } from '../../constants';
import { SONAR_DATA_KEYS } from '../../utils/chart';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ViewRadioGroup from '../view-radio-group/ViewRadioGroup';
import VerticalBars from '../../components/charts/chartjs/sonar-vertical-bars/SonarVerticalBars';

const CHART_INDEX = 0;

function Engagement() {
  const view = useSelector(getViewForChart(SONAR_SECTIONS.PASSION, CHART_INDEX));

  //! TEMPORARY SOLUTION
  let domainEntries = useSelector(getVisibleEntriesForView(view));

  if (domainEntries.length && !domainEntries[0][SONAR_DATA_KEYS.PASSION]) {
    domainEntries = [];
  }

  return (
    <Panel>
      <WithToolbarWrapper>
        <ViewRadioGroup chartIndex={CHART_INDEX} section={SONAR_SECTIONS.PASSION} />

        <VerticalBars
          data={domainEntries}
          dataKey={SONAR_DATA_KEYS.PASSION}
          height='350px'
          customTooltip
          showScore
          showTrend
        />
      </WithToolbarWrapper>
    </Panel>
  );
}

export default Engagement;
